export const passwordResetRequest = {
  message: 'Verification code sent to your email',
  data: {
    email: 'dairoroberto2014@gmail.com'
  }
}

export const verifyResetCode = {
  message: 'Code verification successful',
  data: {
    email: 'dairoroberto2014@gmail.com',
    verified: true
  }
}

export const updatePassword = {
  message: 'Password changed successfully',
  data: {
    email: 'dairoroberto2014@gmail.com'
  }
}
